import { render, staticRenderFns } from "./ListApplications.vue?vue&type=template&id=21dc0423&scoped=true&"
import script from "./ListApplications.vue?vue&type=script&lang=js&"
export * from "./ListApplications.vue?vue&type=script&lang=js&"
import style0 from "./ListApplications.vue?vue&type=style&index=0&id=21dc0423&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21dc0423",
  null
  
)

export default component.exports